import clsx from 'clsx';
import styles from './separator.module.css';

interface SeparatorProps {
  className?: string;
}

export function Separator({ className }: SeparatorProps) {
  return <div className={clsx(styles.separator, className)} />;
}
